export enum ThemeAccent {
	Primary = "primary",
	Secondary = "secondary",
	Accent = "accent",
	Success = "success",
	Warning = "warning",
	Danger = "danger",
	Info = "info",
}

export enum AlertAccent {
	Success = ThemeAccent.Success,
	Warning = ThemeAccent.Warning,
	Danger = ThemeAccent.Danger,
	Info = ThemeAccent.Info,
	Primary = ThemeAccent.Primary,
}

export enum ThemeSize {
	XSmall = "xs",
	Small = "sm",
	Base = "base",
	Large = "lg",
	XLarge = "xl",
}

export enum ThemeButtonVariant {
	Outline = "outline",
	Solid = "solid",
	Ghost = "ghost",
	Link = "link",
}
